import type { AppRouteRecordRaw } from '@/types/router'
import { ROUTE_NAMES } from '@/types/router'

// 国际环境一些零散配置模块
export const specificRoutes: AppRouteRecordRaw[] = [
  {
    path: '/search-ranking',
    name: ROUTE_NAMES.SEARCH_RANKING,
    component: () => import('@/views/SearchRanking.vue'),
    meta: {
      titleKey: 'routeTitle.searchRanking',
      keepAlive: false,
    },
  },
  {
    path: '/special-law',
    name: ROUTE_NAMES.SPECIAL_LAW,
    component: () => import('@/views/special-law.vue'),
    meta: {
      titleKey: 'routeTitle.specialLaw',
      keepAlive: false,
    },
  },
  {
    path: '/add-bank-card',
    name: ROUTE_NAMES.ADD_BANK_CARD,
    component: () => import('@/views/AddBankCard.vue'),
    meta: {
      titleKey: 'routeTitle.addBankCard',
      keepAlive: false,
    },
  },
  {
    path: '/ai-scan-introduce',
    name: ROUTE_NAMES.AI_SCAN_INTRODUCE,
    component: () => import('@/views/aiScanIntroduce.vue'),
    meta: {
      keepAlive: false,
    },
  }
]

export default specificRoutes
